import React, { FunctionComponent, useState } from 'react'
import Button from '../../controls/Button/Button'
import styles from './Menu.module.sass'
import List from '../../data-components/lists/List/List'
import ShadowContainer from '../popover/ShadowContainer/ShadowContainer'
import { isEmpty } from 'fp-ts/es6/Array'
import MenuIcon from 'files/menu/menu-vertical.svg'
import MenuHorizontalIcon from 'files/menu/menu-horizontal.svg'
import { useQueries } from '../../../utils/hooks/useQueries'
import Popover from '../Popover'
import { PopoverAlign } from 'react-tiny-popover'

export interface MenuItem {
    icon?: JSX.Element,
    text?: string,
    onClick: () => void,
    hide?: boolean,
}

interface Props {
    className?: string,
    items: MenuItem[],
    align?: Exclude<PopoverAlign, 'custom'>,
}

const Menu: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)
    const items = props.items.filter(item => !item.hide)

    const { isMobile } = useQueries()

    return <Popover
        isOpen={open}
        padding={0}
        positions={['bottom']}
        align={props.align}
        onClickOutside={() => setOpen(false)}
        contentLocation={isMobile ? ({ childRect, popoverRect }) => {
            return {
                top: childRect.top + childRect.height / 2 - popoverRect.height / 2,
                left: childRect.left + childRect.width - popoverRect.width,
            }
        } : undefined}
        content={<ShadowContainer className={styles.popover}>
            <List<MenuItem>
                className={styles.list}
                data={items}
                onClick={item => {
                    setOpen(false)
                    item.onClick()
                }}
                toKey={item => items.findIndex(x => x === item)}
                render={item => <div className={styles.item}>
                    <div className={styles.icon}>
                        {item.icon}
                    </div>
                    {
                        !isMobile && <div className={styles.text}>
                            {item.text}
                        </div>
                    }
                </div>}
            />
        </ShadowContainer>}
    >
        {
            isEmpty(items) ? <div/> : <Button
                active={open}
                className={props.className}
                onClick={() => setOpen(!open)}
            >
                {isMobile ? <MenuHorizontalIcon/> : <MenuIcon/>}
            </Button>
        }
    </Popover>
}

export default Menu